import React, { useState, Fragment, useContext, useEffect } from "react";
import { Login } from "../../components/backgrounds/Login";
import { useNavigate } from "react-router-dom";
import { RecaptchaView } from "../../components/captcha/recaptcha";
import { SuccessAlert } from "../../components/alerts/successAlert";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { AuthContext } from "../../context/Auth/AuthContext";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import {
  validarSoloNumeros,
  validarEspaciosEnBlanco,
} from "../../utils/validacionesForms";
import { VisitorService } from "../../services/visitors/visitor.service";
import { variablesGlobales } from "../../configs/variables";
import { ColombiaIconInput } from "../../components/inputs/CoIombiaIconInput";

export function SignupPage() {
  const { isValidReCaptcha, updateMail, updatePhone } = useContext(AuthContext);
  const { updateCreditUser, creditUser } = useContext(CreditUserContext);
  const [timer, setTimer] = useState(0);
  const navigate = useNavigate();

  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState();
  const [isOpenError, setIsOpenError] = useState();
  const [viewalert, setViewalert] = useState(false);
  const [errorFieldMail, setErrorFieldMail] = useState("");
  const [errorfieldTypeDoc, setErrorFieldTypeDoc] = useState("");
  const [errorfieldDoc, setErrorFieldDoc] = useState("");
  const [errorfieldPhone, setErrorFieldPhone] = useState("");
  const [formSignup, setFormSignup] = useState({
    typeDocument: "",
    document: "",
    email: "",
    phone: "",
    terms: false,
    policyData: false,
    fuente: localStorage.getItem("utm_id") ?? "Galilea",
  });
  const [channelOtp, setChannelOtp] = useState({ channel: "W" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let isError;
    if (name === "phone") setErrorFieldPhone("");
    if (name === "email") {
      isError = validarEspaciosEnBlanco(name, value);
      if (isError[0]) {
        setErrorFieldMail("El correo no debe contener espacios en blanco.");
      } else {
        setErrorFieldMail("");
      }
    }
    setFormSignup({ ...formSignup, [name]: value });
  };

  const handleChangeSelect = (e) => {
    const { name, value } = e.target;
    if (name === "typeDocument") setErrorFieldTypeDoc("");
    setFormSignup({ ...formSignup, [name]: value });
  };

  const handleChangeChannel = (channel) => {
    setChannelOtp({ channel: channel });
    return;
  };

  const handleOpenAlert = (type, message, isOpen, miliseconds) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(true);
      setTimeout(() => {
        setMessageAlert("");
        setIsOpenSuccess(false);
        setViewalert(false);
      }, 10000);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(true);
      setTimeout(() => {
        setMessageAlert("");
        setIsOpenError(false);
        setViewalert(false);
      }, miliseconds ?? 10000);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  const handleSubmit = async (event) => {
    try {
      let copyCreditInfo = { ...creditUser };
      handleClearStateAlert();
      event.preventDefault();
      //Validación de timer para evitar robots
      //console.log('Tiempo transcurrido rellenando el formulario: ', timer);
      if (timer <= variablesGlobales.timemaxSignupForm) {
        return navigate("/");
      }

      if (!isValidReCaptcha)
        return handleOpenAlert(
          "error",
          "Debes validar el captcha para continuar",
          true
        );

      if (formSignup.typeDocument === "0" || formSignup.typeDocument === 0) {
        setErrorFieldTypeDoc("Debes seleccionar un tipo de documento válido");
        return;
      }

      if (formSignup.email.length <= 0) {
        return setErrorFieldMail("Debes ingresar un correo electrónico");
      }

      let isValidPhone = validarSoloNumeros(formSignup.phone);
      if (!isValidPhone) {
        return setErrorFieldPhone(
          "El número de telefono ingresado no es válido, asegurate de ingresar sólo números"
        );
      }

      if (formSignup.phone.length < 10 || formSignup.phone.length > 10)
        return handleOpenAlert(
          "error",
          "Tu número de teléfono no es válido, por favor verifícalo",
          true
        );

      copyCreditInfo.documento = formSignup.document;
      copyCreditInfo.tasaInteresCorriente = localStorage.getItem('currentInterestRate');
      copyCreditInfo.status = "Solicitado";
      updateCreditUser(copyCreditInfo);

      let payload = Object.assign(
        {},
        {
          user: formSignup,
          creditInfo: copyCreditInfo,
          channelOtp: channelOtp.channel,
        }
      );

      const { message } = await VisitorService.hasClient(formSignup.document, formSignup.email, formSignup.phone);
      handleClearStateAlert();
      if (message?.hasUser) {
        handleOpenAlert(
          "error",
          `El número de documento ya tiene una cuenta en Galilea, te invitamos a ingresar`,
          true
        );
        setTimeout(() => {
          return navigate("/ingresar");
        }, 3000);
      } else if (message?.hasUserEmail === true || message?.hasUserPhone === true) {
        handleOpenAlert(
          "error",
          `El número de teléfono o correo electrónico están asociados a otra cuenta de Galilea`,
          true
        );
        return;
      } else {
        const responseService = await VisitorService.createVisitor(payload);
        if (responseService.error) {
          if (responseService.message?.code === 'DOMAIN') {
            handleOpenAlert(
              "error",
              `${responseService.message?.message}`,
              true
            );
            setTimeout(() => {
              handleClearStateAlert();
              return;
            }, 5000);
          } else if (typeof responseService.message?.message === 'string' && responseService.message?.message.includes('El número de telefono')) {
            handleOpenAlert(
              "error",
              `${responseService.message?.message}`,
              true
            );
            setTimeout(() => {
              handleClearStateAlert();
            }, 5000);
          }
          else {
            handleOpenAlert(
              "error",
              `Ha ocurrido un error interno, intente más tarde`,
              true
            );
            setTimeout(() => {
              handleClearStateAlert();
              return navigate('/');
            }, 5000);
          }
        } else {
          updateMail(formSignup.email);
          updatePhone(formSignup.phone);
          let credit_id = responseService.message?.credit_id;
          localStorage.setItem("doc", formSignup.document);
          localStorage.setItem("is_signin", true);
          localStorage.setItem("phone", formSignup.phone);
          localStorage.setItem("credit_id", credit_id);
          localStorage.setItem("email", formSignup.email);
          return navigate('/validate-phone', { state: { email: localStorage.getItem("phone"), doc: formSignup.document } });
        }
      }
    } catch (error) {
      console.log(error);
      setFormSignup({});
      return handleOpenAlert(
        "error",
        "Ups! Ha ocurrido un error interno, por favor intenta nuevamente!",
        true
      );
    }
  };

  useEffect(() => {
    const isSignin = localStorage.getItem("is_signin");
    const tokenSession = localStorage.getItem("token");

    if (isSignin === true || isSignin === "true") return navigate("/renovar");
    if (tokenSession) return navigate("/renovar");

    //Timer
    setInterval(() => {
      // Incrementar el temporizador en 1 segundo cada segundo
      setTimer(prevTimer => prevTimer + 1);
    }, 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      {viewalert ? (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      ) : (
        <></>
      )}

      <Login
        title="Da el primer paso para ser cliente"
        description="Digita los datos tal como aparece en tu documento de identidad, recuerda
    que esta información será validada por tu seguridad."
        form={
          <form
            action="#"
            method="POST"
            className="space-y-6"
          >
            <div className="grid grid-cols-8 gap-4">
              <div className="col-span-8 lg:col-span-4 grid content-end">
                <label
                  htmlFor="typedocument"
                  className="block text-sm font-medium pb-1"
                >
                  Tipo de documento
                </label>
                <div className="relative rounded-md shadow-sm">
                  <div className="">
                    <select
                      onChange={(choice) => handleChangeSelect(choice)}
                      id="typeDocument"
                      name="typeDocument"
                      className="py-2 px-2 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                    >
                      <option value={0}>Seleccione una opción.</option>
                      <option value={1}>Cédula de ciudadanía</option>
                      <option value={2}>Cédula de extranjería</option>
                    </select>
                  </div>
                </div>
                <span
                  className="text-sm"
                  style={{ color: "#fc3e58", fontStyle: "italic" }}
                >
                  {errorfieldTypeDoc}
                </span>
              </div>

              <div className="col-span-8 lg:col-span-4">
                <label htmlFor="documento" className="text-sm font-medium">
                  Número de documento
                </label>
                <div>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="document"
                    id="document"
                    autoComplete="off"
                    spellCheck={false}
                    required={true}
                    minLength="6"
                    maxLength="10"
                    pattern="[0-9]+"
                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                  />
                </div>
                <span
                  className="text-sm"
                  style={{ color: "#fc3e58", fontStyle: "italic" }}
                >
                  {errorfieldDoc}
                </span>
              </div>

              <div className="col-span-8">
                <label htmlFor="email" className="block text-sm font-medium">
                  Correo electrónico
                </label>

                <div>
                  <input
                    onChange={handleChange}
                    type="email"
                    name="email"
                    id="email"
                    required
                    maxLength="40"
                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                  />
                </div>
                <span
                  className="text-sm"
                  style={{ color: "#fc3e58", fontStyle: "italic" }}
                >
                  {errorFieldMail}
                </span>
              </div>

              <div className="col-span-8">
                <div>
                  <label
                    htmlFor="celular"
                    className="block text-sm font-medium"
                  >
                    Número de WhatsApp
                  </label>
                  <div className="flex rounded-md shadow-sm">
                    <ColombiaIconInput />
                    <input
                      onChange={handleChange}
                      type="number"
                      name="phone"
                      id="phone"
                      autoComplete="tel"
                      className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                    />
                  </div>
                  <span
                    className="text-sm"
                    style={{ color: "#fc3e58", fontStyle: "italic" }}
                  >
                    {errorfieldPhone}
                  </span>
                </div>
              </div>
            </div>

            <div className="items-center">
              <div className="flex items-center">
                <input
                  onChange={handleChange}
                  id="terms"
                  name="terms"
                  required
                  type="checkbox"
                  className="h-4 w-4 text-purple focus:ring-0 border-gray-300 rounded cursor-pointer"
                />
                <label className="ml-2 block">
                  Acepto los{" "}
                  <a href="/terminos" className="text-purple underline">
                    {" "}
                    Términos y condiciones{" "}
                  </a>
                </label>
              </div>

              <div className="flex mt-2 items-center">
                <input
                  onChange={handleChange}
                  id="policyData"
                  name="policyData"
                  required
                  type="checkbox"
                  className="h-4 w-4 text-purple focus:ring-0 border-gray-300 rounded cursor-pointer"
                />
                <label className="ml-2 block">
                  Autorizo el{" "}
                  <a href="/datos" className="text-purple underline">
                    {" "}
                    Tratamiento de datos personales{" "}
                  </a>
                </label>
              </div>
            </div>
            <div className="pt-4">
              <RecaptchaView></RecaptchaView>
            </div>
            <div className="block">
              <div className="text-center pb-4">
                <span className="font-sm text-grayP">
                  Te enviaremos un código a tu WhatsApp para verificar tu cuenta
                </span>
              </div>
              <div className="">
                <div className="w-full">
                  <button
                    onClick={(e) => handleSubmit(e)}
                    type="button"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-none hover:scale-110"
                  >
                    <div className="flex">
                      Empezar
                      <div className="grid content-center pl-2"></div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div className="py-6 flex justify-center">
              <span className="">
                ¿Ya eres cliente?
                <a href="/ingresar" className="text-purple underline pl-2">
                  Ingresa a tu cuenta
                </a>
              </span>
            </div>
          </form>
        }
      />
    </Fragment>
  );
}
